import { ErrorHandler, Injectable, Injector } from '@angular/core';

import * as Sentry from '@sentry/angular';

import { environment } from '../environments/environment';

import { VersionCheckerService } from './version-checker.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  private sentryErrorHandler: Sentry.SentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
    logErrors: !environment.production,
  });

  constructor(private injector: Injector) {}

  public handleError(error: Error): void {
    const chunkFailedMessage: RegExp = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      /* eslint-disable no-console */
      console.log('===FAILED TO LOAD CHUNK===');
      console.log('original error: ');
      console.error(error);
      console.log(error);
      /* eslint-enable no-console */
      const versionCheckerService: VersionCheckerService = this.injector.get(VersionCheckerService);
      versionCheckerService.showPopup();
    }

    this.sentryErrorHandler.handleError(error);
  }
}
